import { Card, Layout, Row } from "antd";
import { Header } from "antd/lib/layout/layout";
import logo from "assets/delphy/delphy.svg";
import Container from "commons/Container";
import successIcon from "assets/icons/Success.svg";
import { Link, useLocation } from "react-router-dom";

export const RegistrationSuccess = () => {
  const location = useLocation();
  return (
    <>
      <Layout className="layout navbar">
        <section className="header">
          <Container>
            <Header className="main-haeder header-menu">
              <Link to="https://delphihc.com/">
                <img src={logo} alt="Bazar Logo" className="main-logo" />
              </Link>
            </Header>
          </Container>
        </section>

        <Container>
          <Card
            className="my-2"
            style={{
              height: "80vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Row justify="center" gutter={20}>
              <div className="no-search">
                <div className="no-search-box">
                  <img src={successIcon} alt="" style={{ width: "200px" }} />
                  <h6>
                    You have successfully registered under{" "}
                    {location?.state?.employerName || ""}
                  </h6>
                  <h4>Welcome to Delphi Enhanced Primary Care! 🥳</h4>
                </div>
              </div>
            </Row>
          </Card>
        </Container>
      </Layout>
    </>
  );
};
